import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { SITE_URL } from "../lib/seo";

/**
 * Visible breadcrumb trail. items = [{ name, path }] (last item is current page, path optional).
 */
export default function Breadcrumbs({ items = [], accent = "#6A1B29" }) {
  if (!items.length) return null;
  return (
    <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className="text-sm text-stone-500">
      <ol className="flex flex-wrap items-center gap-1.5">
        {items.map((it, i) => {
          const last = i === items.length - 1;
          return (
            <li key={i} className="flex items-center gap-1.5">
              {it.path && !last ? (
                <Link to={it.path} className="hover:text-stone-900 transition-colors" data-testid={`breadcrumb-${i}`}>
                  {it.name}
                </Link>
              ) : (
                <span className={last ? "font-medium text-stone-800" : ""} style={last ? { color: accent } : {}} data-testid={`breadcrumb-${i}`}>
                  {it.name}
                </span>
              )}
              {!last && <ChevronRight className="w-3.5 h-3.5 text-stone-300" />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}

export const breadcrumbLd = (items = []) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    ...(it.path ? { item: `${SITE_URL}${it.path}` } : {}),
  })),
});
